import { FunctionComponent, useEffect, useState } from 'react'
import Title from '@/components/_custom/Title/title'
import styles from './activeNotificationAccount.module.scss'
import EmailData from '../emailData'
import validator from 'validator'
import { useTranslation } from 'react-i18next'
import UserInput from '@/components/_custom/UserInput/userInput'
import { EmailUser } from '@/types/EmailHandlerType'
import ButtonText from '@/components/_custom/Buttons/ButtonText/ButtonText'
import { useLazyQuery } from '@apollo/client'
import { EMAIL_EXISTS } from '@/modules/API/software/emailHandler'
import ConfirmActiveNotificationAccountDialog from './Dialog/confirmActiveNotificationAccountDialog'

const ActiveNotificationAccount: FunctionComponent = () => {
    const { t } = useTranslation()

    const [emailActivation, setEmailActivation] = useState<string>('')
    const [emailActivationData, setEmailActivationData] = useState<EmailUser>()

    const [isConfirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false)

    const [getEmailExists, { loading: loadingEmailExist, data: dataEmailExists, error: errorEmailExists }] =
        useLazyQuery(EMAIL_EXISTS, {
            variables: {
                email: emailActivation
            }
        })

    useEffect(() => {
        if (dataEmailExists) {
            setEmailActivationData(dataEmailExists.emailExists)
        }
    }, [dataEmailExists])

    useEffect(() => {
        if (errorEmailExists) {
            setEmailActivationData(undefined)
        }
    }, [errorEmailExists])

    useEffect(() => {
        if (validator.isEmail(emailActivation)) getEmailExists()
    }, [emailActivation])

    return (
        <div className={styles.Form}>
            <Title text={t('activateNotificationAccount')} className={styles.Title} />
            <div className={styles.InputContainer}>
                <div className={styles.Input}>
                    <UserInput
                        value={emailActivation}
                        setValue={setEmailActivation}
                        required={true}
                        label={t('email')}
                        unallowedCharacters={'email'}
                        verify={'email'}
                        type={'text'}
                        className={styles.UserInput}
                    />
                    <EmailData data={emailActivationData} loading={loadingEmailExist} />
                </div>
                <ButtonText
                    text={t('active')}
                    onClick={() => setConfirmDialogOpen(true)}
                    className={styles.Button}
                    disabled={!emailActivationData || loadingEmailExist || !validator.isEmail(emailActivation)}
                />
            </div>
            <ConfirmActiveNotificationAccountDialog
                open={isConfirmDialogOpen}
                emailActivationData={emailActivationData}
                handleClose={() => setConfirmDialogOpen(false)}
                setEmail={setEmailActivation}
                setEmailActivationData={setEmailActivationData}
                email={emailActivation}
            />
        </div>
    )
}

export default ActiveNotificationAccount
